<template>
    <dropdown ref="dropdown" class="mr-8 md:mr-0" placement="bottom-end" :auto-close="false">
        <template #default>
          <span class="cursor-pointer mr-8 relative">
            <font-awesome-icon icon="fa-regular fa-bell" size="2xl" class="text-white" :class="'group-hover:text-white'" />
            <span class="text-white bg-[#C3B577] rounded-full text-center w-5 text-[10px] absolute -right-1/3 -bottom-2">{{ notificationStore.notifications_unviewed }}</span>
          </span>
        </template>
        <template #dropdown>
            <div class="mt-2 bg-white rounded shadow-xl w-72 lg:w-80">
              <div class="text-center uppercase py-3 border-b">Notificações</div>
              <switch-input v-model="onlyUnread" :input-options="{'class': 'w-7 h-4'}" class="flex justify-center items-center text-sm py-3 border-b" labelChecked="Mostrar apenas itens não lidos" labelUnchecked="Mostrar apenas itens não lidos" />
              <div class="pt-3 max-h-[calc(100vh-150px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200">
                <div class="p-3">
                  <div class="mb-3 pb-3 border-b" v-for="(notification, index) in this.notificationStore.notifications">
                    <div class="text-xs text-gray-500">{{ this.$filters.formatDateTime(notification.created_at) }}</div>
                    <div class="flex flex-nowrap items-center justify-between">
                      <div class="text-md">{{ notification.data.title }}</div>
                      <div v-if="!notification.read_at" class="text-xs text-gray-500" title="Marcar como lido"><font-awesome-icon icon="fa-circle-check" class="text-primary cursor-pointer" @click.prevent="markAsRead(notification)" /></div>
                    </div>
                    <div class="text-sm text-gray-500">{{ notification.data.body }}</div>
                  </div>
                  <InfiniteLoading @infinite="load" :identifier="identifier">
                    <template #complete>
                      <div v-if="this.notificationStore.notifications.length" class="text-sm text-gray-500 mb-3">Fim das notificações</div>
                      <div v-else class="text-sm text-gray-500 mb-3">
                        Nenhuma notificação
                      </div>
                    </template>
                    <template #error="{ retry }">
                      <button @click="retry">Recarregar</button>
                    </template>
                    <template #spinner>
                      <div class="flex justify-center mb-6">
                        <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-primary" role="status">
                          <span class="visually-hidden">Carregando...</span>
                        </div>
                      </div>
                    </template>
                  </InfiniteLoading>
                </div>
              </div>
            </div>
        </template>
    </dropdown>
</template>
<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Dropdown from '@/Shared/Components/Dropdown'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import InfiniteLoading from "v3-infinite-loading";
import { useNotificationStore } from '@/Store/Notification'

export default {
  data() {
    return {
      notificationStore: useNotificationStore(),
      identifier: Math.floor(Math.random() * 1000),
      onlyUnread: this.$page.props.auth.user.notification_only_unread == 1,
    }
  },
  components: {
    Dropdown,
    SwitchInput,
    InfiniteLoading,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  watch: {
    onlyUnread() {
      this.notificationStore.setOnlyUnread(this.onlyUnread);
      this.notificationStore.reset();
      this.identifier = Math.floor(Math.random() * 1000);
    },
  },
  methods: {
    load($state) {
      this.notificationStore.loadNotifications().then(() => {
        if(this.notificationStore.total_pages > this.notificationStore.page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    markAsRead(notification) {
      this.notificationStore.markAsRead(notification);
    }
  },
  mounted() {
    this.notificationStore.start();
    this.$watch(() => this.$refs.dropdown.show, (show) => {
      if(show) {
        this.notificationStore.reset();
      }
    });
  },
  unmounted() {
    this.notificationStore.intervalClear();
  },
}
</script>